import { takeEvery, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import axios from "../services";
import { sessionExpiredMsg } from "../constants/constants";

function* getNotificationList(action) {
    try {
        let response = yield axios.get(`/notification?skip=${action.payload}&limit=10`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getNotificationListSuccess({ notifications: response.data.data, newData: action.payload == 0 }));
        }
        if (response.status == 401) {
            let gtoken = localStorage.getItem("gtoken");
            yield localStorage.clear();
            if (gtoken != null) {
                localStorage.setItem("gtoken", gtoken);
            }
            yield put(actions.resetApp());
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }

    } catch (error) {
        yield put(actions.hideAppLoader());
        //  console.log(" 1 ERROR FROM SAGA notification", error.message);
    }
}

function* notificationSwitch(action) {
    try {
        let response = yield axios.put('/users', {
            enableNotification: action.payload.toString()
        })
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.notificationSwitchChange(response.data.data.enableNotification));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        yield put(actions.hideAppLoader());
        console.log("ERROR FROM SAGA notification", error.message);
    }
}

function* notificationMarkAsRead(action) {
    try {
        let response = yield axios.put(`/notification/read-notification/${action.payload.id}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.notificationMarkAsReadSuccess(action.payload));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA notification", error.message);
    }
}

export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_NOTIFICATION_LIST, getNotificationList);
    yield takeEvery(actionTypes.NOTIFICATION_SWITCH, notificationSwitch);
    yield takeEvery(actionTypes.NOTIFICATION_MARK_AS_READ, notificationMarkAsRead);
}
